/* =========================================================================
   Kaikan Cards — De Kluislaag, beweging (kk-kluis, 15 oktober 2026)

   Eén script voor alle kk-kluis-secties. Elke sectie heeft data-kkk='<soort>';
   per sectie één gsap.context, zodat de theme-editor secties kan herladen
   zonder dat ScrollTriggers zich opstapelen (shopify:section:load/unload).

   Begintoestanden zet GSAP zelf (geen verborgen CSS-staat): zonder JS, zonder
   GSAP of met 'minder beweging' staat alles gewoon compleet in beeld.
   De waaier en het formulier werken ook zonder GSAP.

   17 okt 2026 (PageSpeed):
   · een sectie start pas als hij binnen ruim een scherm van beeld komt, in
     plaats van alle secties tegelijk bij het laden (lange taak van ~0,4 s op
     een telefoon). Wat je ziet is hetzelfde: de secties staan klaar voordat
     ze in beeld scrollen.
   · minder volledige herberekeningen van ScrollTrigger: die doet er bij het
     load-event zelf al een, dus die van dit script viel daar dubbel. Na de
     fonts alleen nog als de pagina al geladen was, en na de intro alleen als
     de breedte veranderde (schuifbalk op desktop). Extra aanroepen van
     ST.refresh() van andere secties vóór het load-event vallen weg.

   17 okt 2026 (PageSpeed, ronde 3):
   · LCP: PageSpeed koos het 封-stempel van de intro als grootste element,
     en dat telde pas toen het aan het eind van de intro verscheen (render-
     vertraging 5,9 s). Stempel en kaartjes starten nu op 1% zichtbaarheid
     in plaats van 0%: achter het donkere doek zie je dat niet, maar de
     browser telt ze vanaf de eerste schildering. De intro zelf is precies
     hetzelfde.
   · Kai's lussen in De Poort staan stil zolang de intro eroverheen ligt.
   · Secties starten één voor één, elk in een eigen taak, in plaats van alle
     secties binnen bereik in één lange taak.

   17 okt 2026 (ronde 4): de secties wachten op html.kk-vol (kk-snel), zodat
   ze hun echte plek op de pagina meten. Zie naOpmaak() onderaan.
   ========================================================================= */
(function () {
  'use strict';
  var kkEn = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase() === 'en';
  if (window.__kkKluis) return;
  window.__kkKluis = true;

  var RUSTIG = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MUIS = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var G = window.gsap, ST = window.ScrollTrigger, SPLIT = window.SplitText;
  var BEWEGING = !!(G && ST && !RUSTIG);
  if (G && ST) G.registerPlugin(ST);
  if (G && SPLIT) G.registerPlugin(SPLIT);
  if (ST) ST.config({ ignoreMobileResize: true });

  /* 17 okt 2026 (PageSpeed): ScrollTrigger ververst zelf al bij
     DOMContentLoaded en bij load. Secties die daarnaast zelf ST.refresh()
     aanroepen (De Poort bij het starten en bij load) lieten die volledige
     meting van alle triggers dubbel lopen: elk een lange taak op een
     telefoon. Vóór het load-event doen we die extra aanroepen niet, en een
     aanroep vlak na een verversing (binnen 200 ms) slaan we over. Triggers
     meten zichzelf bij het aanmaken, en bij load ververst alles toch. */
  if (ST && !ST.__kkZuinig) {
    ST.__kkZuinig = true;
    var echtRefresh = ST.refresh, laatsteRefresh = 0;
    ST.addEventListener('refresh', function () { laatsteRefresh = Date.now(); });
    ST.refresh = function () {
      if (document.readyState !== 'complete') return;
      if (Date.now() - laatsteRefresh < 200) return;
      return echtRefresh.apply(ST, arguments);
    };
  }

  var contexten = new WeakMap();
  var opruimers = new WeakMap();

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------------
     Intro: teller 000 -> 100, kaarten vliegen binnen, stempel slaat erop,
     daarna schuift het doek omhoog. Alleen als het inline script in de
     sectie html.kkk-intro-aan heeft gezet. (17 okt: langer, ~4,4 s, en de
     teller wacht bij 86 op het laden van de pagina erachter.)
     --------------------------------------------------------------------- */
  function intro() {
    var html = document.documentElement;
    var doek = $('.kkki');
    if (!doek || !html.classList.contains('kkk-intro-aan')) return;
    var klaar = false;
    function weg() {
      if (klaar) return; klaar = true;
      var breed = html.clientWidth;
      html.classList.remove('kkk-intro-aan');
      try { sessionStorage.setItem('kkk-intro', '1'); } catch (e) {}
      if (ST && html.clientWidth !== breed) ST.refresh();
      document.dispatchEvent(new CustomEvent('kkk:intro-klaar'));
    }
    if (!G) { setTimeout(weg, 900); return; }
    var tel = $('.kkki__tel', doek), balk = $('.kkki__balk i', doek);
    var kaarten = $$('.kkki__kaart', doek), stempel = $('.kkki__stempel', doek);
    var teller = { v: 0 };
    function schrijf() {
      var n = Math.round(teller.v);
      if (tel) tel.textContent = (n < 10 ? '00' : n < 100 ? '0' : '') + n;
      if (balk) balk.style.transform = 'scaleX(' + (teller.v / 100) + ')';
    }
    /* De teller loopt rustig naar 86 en wacht daar tot de pagina achter het
       doek geladen is (window load), hooguit 1,8 s extra. Dan 86 -> 100,
       stempel, doek omhoog. Snelle verbinding: ~4,4 s; trage: max ~6,2 s. */
    var geladen = document.readyState === 'complete', wacht = false, over = false;
    var tl = G.timeline({ onComplete: weg });
    function verder() { if (wacht && !over) { wacht = false; tl.play(); } }
    window.addEventListener('load', function () { geladen = true; verder(); });
    G.set(kaarten, { yPercent: 140, rotation: function (i) { return [-24, 18, -6][i % 3]; }, opacity: .01 });
    G.set(stempel, { scale: 2.6, opacity: .01, rotation: -24 });
    tl.to(teller, { v: 86, duration: 2.4, ease: 'power1.inOut', onUpdate: schrijf }, 0)
      .to(kaarten, { yPercent: 0, opacity: 1, duration: 1.3, ease: 'expo.out', stagger: .3,
        rotation: function (i) { return [-14, 9, -2][i % 3]; } }, .15)
      .call(function () {
        if (geladen || over) return;
        wacht = true; tl.pause();
        setTimeout(function () { geladen = true; verder(); }, 1800);
      }, null, 2.4)
      .to(teller, { v: 100, duration: .7, ease: 'power2.out', onUpdate: schrijf }, 2.4)
      .to(stempel, { scale: 1, opacity: 1, rotation: -9, duration: .32, ease: 'power4.in' }, 2.85)
      .to(doek, { x: 6, duration: .05, yoyo: true, repeat: 3, ease: 'none' }, 3.17)
      .to(doek, { yPercent: -100, duration: .85, ease: 'expo.inOut' }, 3.55);
    /* Kai's lussen (staart, lantaarn, oor, ogen) in De Poort draaien niet
       zolang het doek erover ligt; De Poort start ze soms pas na deze
       functie, dus een paar keer kijken. Na de intro beslist De Poort weer
       zelf (in beeld = lopen). */
    var kaiStil = [];
    function stilKai() {
      var kai = $('.kkpo__kai');
      if (!kai || klaar) return;
      G.getTweensOf(kai.querySelectorAll('*')).forEach(function (t) {
        if (kaiStil.indexOf(t) < 0 && !t.paused()) { t.pause(); kaiStil.push(t); }
      });
    }
    [0, 400, 1200, 2500].forEach(function (ms) { setTimeout(stilKai, ms); });
    document.addEventListener('kkk:intro-klaar', function () {
      kaiStil.forEach(function (t) { t.resume(); });
      kaiStil = [];
    }, { once: true });
    function sla() { over = true; wacht = false; tl.progress(1); weg(); }
    doek.addEventListener('click', sla);
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { sla(); document.removeEventListener('keydown', esc); } });
  }

  /* ---------------------------------------------------------------------
     Gedeelde trucs, binnen één sectie
     --------------------------------------------------------------------- */
  function koppen(root) {
    $$('.kkk-mega', root).forEach(function (kop) {
      var inkt = $$('.kkk-inkt', kop), door = $$('.kkk-door', kop), streek = $$('.kkk-inkt__streek path', kop);
      var regels = $$('.kkk-mega__regel', kop);
      var tl = G.timeline({ scrollTrigger: { trigger: kop, start: 'top 82%', once: true } });
      if (regels.length) {
        G.set(regels, { yPercent: 40, opacity: 0, skewY: 4 });
        tl.to(regels, { yPercent: 0, opacity: 1, skewY: 0, duration: .9, ease: 'expo.out', stagger: .1 }, 0);
      }
      if (door.length) {
        door.forEach(function (d) { d.style.setProperty('--kkk-door', 0); });
        tl.to(door, { '--kkk-door': 1, duration: .45, ease: 'power3.in' }, .55);
      }
      if (inkt.length) {
        G.set(inkt, { clipPath: 'inset(-20% 100% -30% -6%)', filter: 'blur(8px)' });
        tl.to(inkt, { clipPath: 'inset(-20% -6% -30% -6%)', filter: 'blur(0px)', duration: 1, ease: 'power2.out' }, door.length ? .95 : .45);
      }
      streek.forEach(function (p) {
        var l = p.getTotalLength ? p.getTotalLength() : 300;
        G.set(p, { strokeDasharray: l, strokeDashoffset: l });
        tl.to(p, { strokeDashoffset: 0, duration: .55, ease: 'power2.inOut' }, '-=.35');
      });
    });
    $$('.kkk-label', root).forEach(function (l) {
      G.from(l, { x: -18, opacity: 0, duration: .7, ease: 'power3.out', scrollTrigger: { trigger: l, start: 'top 88%', once: true } });
      var z = $('.kkk-label__zegel', l);
      if (z) G.from(z, { scale: 2.2, rotation: -40, opacity: 0, duration: .45, ease: 'back.out(2)', delay: .1, scrollTrigger: { trigger: l, start: 'top 88%', once: true } });
    });
    $$('.kkk-spook', root).forEach(function (s) {
      G.fromTo(s, { yPercent: -10 }, { yPercent: 18, ease: 'none', scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: .6 } });
    });
    $$('[data-kkk-in]', root).forEach(function (groep) {
      var kids = groep.children.length ? Array.prototype.slice.call(groep.children) : [groep];
      G.from(kids, { y: 26, opacity: 0, duration: .8, ease: 'power3.out', stagger: .07,
        scrollTrigger: { trigger: groep, start: 'top 86%', once: true } });
    });
    $$('.kkk-knop', root).forEach(function (k) {
      if (k.classList.contains('kkk-knop--lijn')) return;
      k.style.setProperty('--kkk-drup', 0);
      G.to(k, { '--kkk-drup': 1, duration: 1.1, ease: 'power2.out', delay: .3, scrollTrigger: { trigger: k, start: 'top 92%', once: true } });
    });
    $$('[data-kkk-woorden]', root).forEach(function (blok) {
      if (!SPLIT) return;
      SPLIT.create(blok, { type: 'words', aria: 'auto', onSplit: function (s) {
        return G.fromTo(s.words, { opacity: .16 }, { opacity: 1, stagger: .05, ease: 'none',
          scrollTrigger: { trigger: blok, start: 'top 78%', end: 'bottom 52%', scrub: .5 } });
      } });
    });
    $$('.kkk-tape', root).forEach(function (t, i) {
      var band = $('.kkk-tape__band', t);
      G.from(t, { clipPath: i % 2 ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)', duration: 1.1, ease: 'expo.inOut',
        scrollTrigger: { trigger: t, start: 'top 92%', once: true } });
      if (band) G.fromTo(band, { xPercent: i % 2 ? -18 : 0 }, { xPercent: i % 2 ? 0 : -18, ease: 'none',
        scrollTrigger: { trigger: t, start: 'top bottom', end: 'bottom top', scrub: .4 } });
    });
    $$('[data-kkk-slam]', root).forEach(function (st) {
      var r = parseFloat(getComputedStyle(st).getPropertyValue('--kkk-rot')) || -7;
      G.fromTo(st, { scale: 2.4, opacity: 0, rotation: r - 18 }, { scale: 1, opacity: 1, rotation: r, duration: .34, ease: 'power4.in',
        delay: parseFloat(st.getAttribute('data-kkk-slam')) || 0,
        scrollTrigger: { trigger: st, start: 'top 90%', once: true } });
    });
    $$('[data-kkk-tel]', root).forEach(function (el) {
      var doel = parseFloat(el.getAttribute('data-kkk-tel')) || 0;
      var dec = parseInt(el.getAttribute('data-kkk-dec') || '0', 10);
      var o = { v: 0 };
      var schrijf = function () { el.textContent = kkEn ? o.v.toFixed(dec) : o.v.toFixed(dec).replace('.', ','); };
      schrijf();
      G.to(o, { v: doel, duration: 1.6, ease: 'power3.out', onUpdate: schrijf,
        scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
    });
  }

  /* Kaarten kantelen onder de muis (alleen met een fijne aanwijzer). */
  function kantel(root) {
    if (!MUIS || RUSTIG) return;
    $$('.kkk-kaart[data-kkk-kantel]', root).forEach(function (k) {
      var rx = G ? G.quickTo(k, 'rotationX', { duration: .5, ease: 'power3' }) : null;
      var ry = G ? G.quickTo(k, 'rotationY', { duration: .5, ease: 'power3' }) : null;
      function beweeg(e) {
        var b = k.getBoundingClientRect();
        var x = (e.clientX - b.left) / b.width, y = (e.clientY - b.top) / b.height;
        k.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        k.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        if (rx) { rx((.5 - y) * 14); ry((x - .5) * 16); }
      }
      function uit() { if (rx) { rx(0); ry(0); } }
      k.addEventListener('pointermove', beweeg);
      k.addEventListener('pointerleave', uit);
    });
  }

  /* ---------------------------------------------------------------------
     Statement: de drie kaarten bovenaan waaieren open bij het scrollen.
     x en y staan expliciet op 0: anders telt GSAP de CSS-verschuiving uit
     de sectie nog eens op bij xPercent.
     --------------------------------------------------------------------- */
  function statement(root) {
    var kaarten = $$('.kkks__kaart', root);
    if (!kaarten.length) return;
    var hoek = [-13, 8, -2], x = [-44, 40, 0], y = [4, -6, 10];
    G.fromTo(kaarten, {
      x: 0, y: 0, yPercent: 40, rotation: function (i) { return [-2, 2, 0][i % 3]; }, xPercent: 0, opacity: 0
    }, {
      x: 0, y: 0, yPercent: function (i) { return y[i % 3]; }, xPercent: function (i) { return x[i % 3]; },
      rotation: function (i) { return hoek[i % 3]; }, opacity: 1, ease: 'power2.out', stagger: .04,
      scrollTrigger: { trigger: root, start: 'top 85%', end: 'top 25%', scrub: .7 }
    });
  }

  /* ---------------------------------------------------------------------
     Route: vier kaarten vallen schuin op hun plek.
     --------------------------------------------------------------------- */
  function route(root) {
    var kaarten = $$('.kkkr__stap', root);
    if (!kaarten.length) return;
    G.from(kaarten, { y: 120, rotation: function (i) { return i % 2 ? 9 : -9; }, opacity: 0, duration: 1, ease: 'expo.out', stagger: .12,
      scrollTrigger: { trigger: $('.kkkr__stappen', root), start: 'top 85%', once: true } });
  }

  /* ---------------------------------------------------------------------
     Record: stickers vallen, het logboek stempelt rij voor rij.
     --------------------------------------------------------------------- */
  function record(root) {
    var stickers = $$('.kkkd__sticker', root);
    if (stickers.length) {
      G.from(stickers, { y: -80, rotation: function (i) { return i % 2 ? 22 : -22; }, opacity: 0, scale: 1.15, duration: .8,
        ease: 'back.out(1.6)', stagger: .12, scrollTrigger: { trigger: $('.kkkd__stickers', root), start: 'top 82%', once: true } });
    }
    $$('.kkkd__rij', root).forEach(function (rij) {
      var st = $('.kkk-stempel', rij);
      var tl = G.timeline({ scrollTrigger: { trigger: rij, start: 'top 92%', once: true } });
      tl.from(rij, { x: -30, opacity: 0, duration: .55, ease: 'power3.out' });
      if (st) tl.fromTo(st, { scale: 2.6, opacity: 0, rotation: -26 }, { scale: 1, opacity: 1, rotation: -7, duration: .3, ease: 'power4.in' }, .25);
    });
  }

  /* ---------------------------------------------------------------------
     Drop: de tapes trekken strak en de kaart kantelt binnen.
     --------------------------------------------------------------------- */
  function drop(root) {
    var vel = $('.kkkx__vel', root), kaart = $('.kkkx__kaart', root);
    var tapes = $$('.kkkx__tape', root);
    var tl = G.timeline({ scrollTrigger: { trigger: vel || root, start: 'top 80%', once: true } });
    if (vel) tl.from(vel, { y: 60, rotation: -3, opacity: 0, duration: .9, ease: 'expo.out' }, 0);
    if (tapes.length) tl.from(tapes, { scaleX: 0, duration: .7, ease: 'expo.inOut', stagger: .12 }, .2);
    if (kaart) tl.from(kaart, { xPercent: 40, rotation: 24, opacity: 0, duration: 1, ease: 'expo.out' }, .35);
  }

  /* ---------------------------------------------------------------------
     Lid: de kaart rechts zweeft licht mee.
     --------------------------------------------------------------------- */
  function lid(root) {
    var kaart = $('.kkkl__kaart', root);
    if (kaart) G.fromTo(kaart, { yPercent: 18, rotation: 18 }, { yPercent: -10, rotation: 8, ease: 'none',
      scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: .6 } });
  }

  /* ---------------------------------------------------------------------
     Waaier: werkt ook zonder GSAP (dan met inline transforms).
     --------------------------------------------------------------------- */
  function waaier(root) {
    var podium = $('.kkkw__podium', root);
    var kaarten = $$('.kkkw__item', root);
    if (!podium || kaarten.length < 2) return function () {};
    root.classList.add('kkkw--js');
    var balk = $('.kkkw__balk', root);
    var velden = { code: $("[data-veld='code']", root), naam: $("[data-veld='naam']", root), info: $("[data-veld='info']", root), prijs: $("[data-veld='prijs']", root), staat: $("[data-veld='staat']", root) };
    var knopLink = $('.kkkw__naar', root);
    var vorige = $('.kkkw__pijl--terug', root), volgende = $('.kkkw__pijl--door', root);
    var actief = Math.min(kaarten.length - 1, Math.floor(kaarten.length / 2));
    var auto = null, aangeraakt = false, inBeeld = false;

    function maat() {
      var w = podium.clientWidth;
      return { stap: Math.max(70, Math.min(170, w * .13)), smal: w < 640 };
    }
    function zet(n, direct) {
      actief = (n + kaarten.length) % kaarten.length;
      var m = maat();
      kaarten.forEach(function (k, i) {
        var d = i - actief;
        var a = Math.abs(d);
        var zicht = a <= (m.smal ? 2 : 3);
        var doel = {
          x: d * m.stap * (m.smal ? .78 : 1),
          y: Math.pow(a, 1.35) * (m.smal ? 14 : 22) - (a === 0 ? 26 : 0),
          rotation: d * (m.smal ? 6 : 7),
          scale: a === 0 ? 1.08 : 1 - a * .07,
          opacity: zicht ? 1 : 0,
          zIndex: 100 - a
        };
        k.classList.toggle('is-actief', a === 0);
        k.setAttribute('aria-hidden', zicht ? 'false' : 'true');
        var link = $('a', k); if (link) link.tabIndex = a === 0 ? 0 : -1;
        if (G && !RUSTIG && !direct) G.to(k, Object.assign({ duration: .7, ease: 'expo.out', overwrite: true }, doel));
        else if (G) G.set(k, doel);
        else {
          k.style.zIndex = doel.zIndex; k.style.opacity = doel.opacity;
          k.style.transform = 'translate(' + doel.x + 'px,' + doel.y + 'px) rotate(' + doel.rotation + 'deg) scale(' + doel.scale + ')';
        }
      });
      var k = kaarten[actief];
      Object.keys(velden).forEach(function (v) { if (velden[v]) velden[v].textContent = k.getAttribute('data-' + v) || ''; });
      if (velden.staat) velden.staat.setAttribute('data-staat', k.getAttribute('data-staat-sleutel') || '');
      if (knopLink) knopLink.href = k.getAttribute('data-url') || knopLink.href;
      if (balk && G && !RUSTIG && !direct) G.fromTo(balk, { y: 8, opacity: .3 }, { y: 0, opacity: 1, duration: .45, ease: 'power3.out', overwrite: true });
    }
    function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }
    function startAuto() {
      stopAuto();
      if (aangeraakt || RUSTIG || !inBeeld) return;
      auto = setInterval(function () { zet(actief + 1); }, 4200);
    }
    function gebruiker() { aangeraakt = true; stopAuto(); }

    kaarten.forEach(function (k, i) {
      k.addEventListener('click', function (e) {
        if (i !== actief) { e.preventDefault(); gebruiker(); zet(i); }
      });
    });
    if (vorige) vorige.addEventListener('click', function () { gebruiker(); zet(actief - 1); });
    if (volgende) volgende.addEventListener('click', function () { gebruiker(); zet(actief + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { gebruiker(); zet(actief - 1); }
      if (e.key === 'ArrowRight') { gebruiker(); zet(actief + 1); }
    });
    var sx = null, sy = null;
    podium.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; }, { passive: true });
    podium.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { gebruiker(); zet(actief + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    root.addEventListener('pointerenter', stopAuto);
    root.addEventListener('pointerleave', startAuto);
    var io = new IntersectionObserver(function (l) { inBeeld = l[0].isIntersecting; inBeeld ? startAuto() : stopAuto(); }, { threshold: .35 });
    io.observe(podium);
    var rs = function () { zet(actief, true); };
    window.addEventListener('resize', rs);
    zet(actief, true);
    if (BEWEGING) {
      G.from(kaarten, { y: 160, rotation: 0, opacity: 0, duration: 1, ease: 'expo.out', stagger: .06, immediateRender: false,
        scrollTrigger: { trigger: podium, start: 'top 85%', once: true }, onComplete: function () { zet(actief); } });
    }
    return function () { stopAuto(); io.disconnect(); window.removeEventListener('resize', rs); };
  }

  /* ---------------------------------------------------------------------
     Lid: aanmelden bij Klaviyo (zelfde aanpak als kk-drop-alert).
     --------------------------------------------------------------------- */
  function formulier(root) {
    var form = $('.kkkl__form', root);
    if (!form || form.__kkk) return;
    form.__kkk = true;
    var company = form.getAttribute('data-company'), lijst = form.getAttribute('data-lijst');
    if (!company || !lijst) return;
    var mail = form.elements.email, knop = $('button', form), melding = $('.kkkl__melding', root);
    function zeg(t, fout) { if (!melding) return; melding.textContent = t || ''; melding.classList.toggle('is-fout', !!fout); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.elements.website && form.elements.website.value) return;
      var email = (mail.value || '').trim();
      if (!/^[^ @]+@[^ @]+[.][^ @]{2,}$/.test(email)) { zeg(form.getAttribute('data-fout-mail'), true); mail.focus(); return; }
      knop.disabled = true; zeg(form.getAttribute('data-bezig'));
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: form.getAttribute('data-bron') || 'Homepage kluis',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        }, relationships: { list: { data: { type: 'list', id: lijst } } } } })
      }).then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error(r.status);
        root.classList.add('is-klaar');
        var k = $('.kkkl__klaar', root); if (k) k.focus();
        if (G && !RUSTIG) { var s = $('.kkkl__klaar .kkk-stempel', root); if (s) G.fromTo(s, { scale: 2.6, opacity: 0, rotation: -28 }, { scale: 1, opacity: 1, rotation: -8, duration: .32, ease: 'power4.in' }); }
      }).catch(function () { knop.disabled = false; zeg(form.getAttribute('data-fout'), true); });
    });
  }

  /* ---------------------------------------------------------------------
     Opstarten per sectie
     --------------------------------------------------------------------- */
  function init(root) {
    if (!root || !root.getAttribute) return;
    ruim(root);
    var soort = root.getAttribute('data-kkk');
    var extra = [];
    if (soort === 'waaier') extra.push(waaier(root));
    if (soort === 'lid') formulier(root);
    if (BEWEGING) {
      contexten.set(root, G.context(function () {
        koppen(root);
        kantel(root);
        if (soort === 'statement') statement(root);
        if (soort === 'route') route(root);
        if (soort === 'record') record(root);
        if (soort === 'drop') drop(root);
        if (soort === 'lid') lid(root);
      }, root));
    } else if (G) {
      kantel(root);
    }
    opruimers.set(root, extra);
  }
  function ruim(root) {
    var c = contexten.get(root); if (c) { c.revert(); contexten.delete(root); }
    var o = opruimers.get(root); if (o) { o.forEach(function (f) { if (typeof f === 'function') f(); }); opruimers.delete(root); }
  }
  /* Secties starten zodra ze binnen ruim twee schermen van beeld komen, of
     als je er al voorbij bent (snel scrollen, een #anker, terug naar boven).
     In de theme-editor meteen, zoals voorheen. */
  function startSecties() {
    var wachtend = $$('[data-kkk]');
    if (window.Shopify && window.Shopify.designMode) { wachtend.forEach(init); return; }
    var gepland = false, rij = [], rijLoopt = false, eerste = true;
    /* Elke sectie in een eigen taak: zo blijft de pagina tussendoor
       bereikbaar voor tikken en scrollen (geen lange taak van 0,5 s). */
    function volgende() {
      var s = rij.shift();
      if (!s) { rijLoopt = false; return; }
      init(s);
      setTimeout(volgende, 0);
    }
    function zetInRij(s) {
      rij.push(s);
      if (!rijLoopt) { rijLoopt = true; setTimeout(volgende, 0); }
    }
    function kijk() {
      gepland = false;
      var grens = window.innerHeight * 2.2;
      /* eerst alles meten, dan pas starten: geen meting na een wijziging */
      var tops = wachtend.map(function (s) { return s.getBoundingClientRect().top; });
      var zicht = window.innerHeight;
      wachtend = wachtend.filter(function (s, i) {
        if (tops[i] < grens) {
          /* wat nu al in beeld staat meteen (geen flits van de eindstand),
             de rest één voor één */
          if (eerste && tops[i] < zicht) init(s); else zetInRij(s);
          return false;
        }
        return true;
      });
      eerste = false;
      if (!wachtend.length) {
        window.removeEventListener('scroll', plan);
        window.removeEventListener('resize', plan);
      }
    }
    function plan() { if (!gepland) { gepland = true; window.requestAnimationFrame(kijk); } }
    window.addEventListener('scroll', plan, { passive: true });
    window.addEventListener('resize', plan, { passive: true });
    kijk();
  }
  /* 17 okt 2026 (ronde 4): op de homepage zet kk-snel na de eerste
     schildering html.kk-vol, en pas dan staan alle secties op hun echte
     hoogte in de opmaak (zie de uitleg in snippets/kk-snel.liquid). Tot dat
     moment zijn ze op de telefoon 0 px hoog en zou elke sectie direct onder
     De Poort lijken te staan. Daarom wachten de secties daarop (vangnet
     1,5 s). Op andere pagina's starten ze meteen, zoals voorheen. */
  function naOpmaak(f) {
    var html = document.documentElement;
    if (html.classList.contains('kk-vol') || !document.body || !document.body.classList.contains('template-index')) { f(); return; }
    var klaar = false;
    function ga() { if (klaar) return; klaar = true; f(); }
    document.addEventListener('kk:vol', ga, { once: true });
    setTimeout(ga, 1500);
  }
  function boot() {
    intro();
    naOpmaak(startSecties);
    /* ScrollTrigger ververst zelf al bij het load-event. Komen de fonts pas
       daarna binnen, dan hier nog één keer. */
    if (ST && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (document.readyState === 'complete') ST.refresh(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { var r = $('[data-kkk]', e.target); if (r) init(r); });
    document.addEventListener('shopify:section:unload', function (e) { var r = $('[data-kkk]', e.target); if (r) ruim(r); });
    document.addEventListener('shopify:section:select', function () { if (ST) ST.refresh(); });
  }
})();
